import { store } from "@risingstack/react-easy-state";
import { patterns, colors, messages } from "../origamiConfig";


const OrigamiSelectionStore = store({
    selectedMessage: messages[0],
    selectedColor: colors[0],
    selectedPattern: patterns[0],
    updateMessage:(index)=>{
        OrigamiSelectionStore.selectedMessage = index
    },
    updateColor:(item)=>{
        OrigamiSelectionStore.selectedColor = item
    },
    updatePattern:(item)=>{
        OrigamiSelectionStore.selectedPattern = item
    },
});

export default OrigamiSelectionStore;